<script setup lang="ts">
  import { inject } from 'vue';

  import type { Attachment, Task } from '@stuut/api/models';

  import { stuut } from '@/api';
  import AttachmentItem from '@/components/attachments/AttachmentItem.vue';

  import { FileDropzoneKey } from '../file-upload-dropzone';
  import type { FileDropzoneProviderContext } from '../file-upload-dropzone';

  interface Props {
    attachment: Attachment;
    hideDelete?: boolean;
    task: Task;
    truncate?: number;
  }

  const props = defineProps<Props>();
  const fileDropzone = inject<FileDropzoneProviderContext | undefined>(FileDropzoneKey, undefined);
</script>

<template>
  <AttachmentItem
    :attachment="attachment"
    truncate
    :max-length="truncate"
    :uploading="attachment.is_uploading"
    :hide-delete="hideDelete"
    @delete="
      async () => {
        try {
          await stuut.tasks.removeAttachment(task, attachment);
          fileDropzone?.removeFileAttachment(attachment);
        } catch (error: any) {
          console.error('Error removing attachment: ', error);
        }
      }
    "
  />
</template>

<style scoped></style>
